export default "__VITE_ASSET__DZfTf779__"